module.exports = __webpack_public_path__ + "fonts/la-regular-400.8dc1ced.woff2";